<template>
  <div class="task-column" :class="columnColor">
    <div class="task-column__head">
      <div class="task-column__title">{{ column.name }}</div>
      <!--<div class="task-column__menu" @click.stop="toggleControls(column.id)">
        <svg width="23" height="4" viewBox="0 0 23 4" fill="none" xmlns="http://www.w3.org/2000/svg">
          <circle cx="2" cy="2" r="2" fill="currentColor"/>
          <circle cx="11" cy="2" r="2" fill="currentColor"/>
          <circle cx="21" cy="2" r="2" fill="currentColor"/>
        </svg>
        <div class="task-column__menu-controls">
          <transition name="fade">
            <AppPopupControls v-if="column.isControlsActive" @edit-this-item="editItem" @remove-this-item="removeItem"/>
          </transition>
        </div>
      </div>-->
    </div>
    <Container group-name="column"
               drag-class="card-item_drag"
               :get-child-payload="getPayload"
               @drag-start="(e) => onCardPick(column.id, e)"
               @drop="(e) => onCardDrop(column.id, e)"
    >
      <Draggable class="card-item"
                 v-for="task in column.tasks"
                 :key="task.id"
      >
        <TaskBoardCard :task="task"
                       @show-info="showTaskInfo"
        />
      </Draggable>
    </Container>
  </div>
</template>

<script>

import TaskBoardCard from '@/components/task/TaskBoardCard'
/* import AppPopupControls from '@/components/page/popup/AppPopupControls' */
import { Container, Draggable } from 'vue-smooth-dnd'
export default {
  name: 'task-board-column',
  components: {
    /* AppPopupControls, */
    TaskBoardCard,
    Container,
    Draggable
  },
  props: {
    column: Object
  },
  computed: {
    columnColor () {
      return {
        blue: this.column.color === 'blue',
        orange: this.column.color === 'orange',
        pink: this.column.color === 'pink',
        green: this.column.color === 'green',
        purple: this.column.color === 'purple',
        violet: this.column.color === 'violet'
      }
    }
  },
  data () {
    return {}
  },
  methods: {
    toggleControls (columnId) {
      this.$emit('toggle-column-controls', columnId)
    },
    editItem () {
      this.$emit('update-column', this.column.id)
    },
    removeItem () {
      this.$emit('remove-column', this.column.id)
    },
    showTaskInfo (taskId) {
      this.$emit('show-task-info', taskId)
    },
    getPayload (index) {
      return { cardIndex: index }
    },
    onCardPick (columnId, event) {
      if (event.isSource) {
        const data = {
          columnId: columnId,
          cardIndex: event.payload.cardIndex
        }
        this.$emit('card-pick', data)
      }
    },
    onCardDrop (columnId, dropResult) {
      if (dropResult.removedIndex !== null || dropResult.addedIndex !== null) {
        const data = {
          columnId: columnId,
          dropResult: dropResult
        }
        this.$emit('card-drop', data)
      }
    }
  }
}

</script>

<style lang="scss" scoped>
@import '../../assets/css/system/_vars';
@import '../../assets/css/system/_mixins';

.task-column {
  width: 356px;
  padding: 16px 16px 20px 16px;
  border-radius: 3px;
  cursor: pointer;

  &__head {
    display: flex;
    flex-flow: row nowrap;
    align-items: center;
    justify-content: space-between;
    color: $font_color_alt;
    margin-bottom: 16px;
  }

  &__menu {
    position: relative;
    cursor: pointer;
    user-select: none;
    transition: .3s;

    &:hover {
      color: $color_second;
    }
  }

  &__menu-controls {
    position: absolute;
    top: calc(100% + 5px);
    left: auto;
    right: -4px;
  }

  &.blue {
    background: #2278BA;
    background: linear-gradient(90deg, #6672B1 0%, #2278BA 100%);
  }

  &.orange {
    background: #F86758;
    background: linear-gradient(95.94deg, #FAA658 -20.08%, #F86758 122.58%);
  }

  &.pink {
    background: #D75798;
    background: linear-gradient(102.64deg, #E8506F 9.26%, #D75798 100%);
  }

  &.green {
    background: #83BC70;
    background: linear-gradient(90deg, #559E97 -18.5%, #83BC70 119.25%);
  }

  &.purple {
    background: #790D7F;
    background: linear-gradient(90deg, #BC1183 -18.5%, #790D7F 119.25%);
  }

  &.violet {
    background: #143568;
    background: linear-gradient(90deg, #6E34B8 -18.5%, #143568 119.25%);
  }
}

.card-item {
  margin-bottom: 12px;

  &_drag {
    transition: .3s;
    cursor: grabbing;
    transform: rotate(-5deg);
  }

  &:last-child {
    margin-bottom: 0;
  }
}
</style>
